import type {Dispatch, GetState, ThunkAction} from 'src/reducers';
import type {AudienceListTableEntry} from 'src/types/audience-list';

import * as reduxApi from 'src/utils/redux-api-v2';
import {captureSentryException} from 'src/utils/sentry';
import {
  selectLists,
  selectListsMapAcrossPages,
} from 'src/selectors/audience-lists';
import {ROI_SETUP_GATE_NAMES} from 'src/utils/performance';


const ROI_SETUP_TASK_PATH = 'analytics/onboarding/task/ROI_SETUP';

const completeRoiSetupTask =
  (): ThunkAction<void> => async (dispatch: Dispatch) => {
    try {
      await dispatch(
        reduxApi.patch(ROI_SETUP_TASK_PATH, {status: 'COMPLETED'}),
      );
    } catch (err) {
      captureSentryException(err, {
        tags: {context: 'completeRoiSetupTask'},
      });
    }
  };

const collectKnownListNames = (
  state: ReturnType<GetState>,
): Set<string | undefined> => {
  const known = new Set<string | undefined>();
  selectLists(state).forEach((list: AudienceListTableEntry) => {
    if (list?.id) {
      known.add(list.name);
    }
  });
  const listsMap = selectListsMapAcrossPages(state);
  if (listsMap && typeof listsMap.forEach === 'function') {
    listsMap.forEach((pageLists) => {
      pageLists?.forEach?.((list: AudienceListTableEntry) => {
        if (list?.id) {
          known.add(list.name);
        }
      });
    });
  }
  return known;
};

export const maybeCompleteRoiSetup =
  (createdListName: string): ThunkAction<void> =>
  async (dispatch: Dispatch, getState: GetState) => {
    if (
      !(ROI_SETUP_GATE_NAMES as readonly string[]).includes(createdListName)
    ) {
      return;
    }
    const known = collectKnownListNames(getState());
    known.add(createdListName);
    const missing = ROI_SETUP_GATE_NAMES.filter((g) => !known.has(g));
    const allGatesPresent = missing.length === 0;
    if (allGatesPresent) {
      dispatch(completeRoiSetupTask());
    }
  };
